var uint8 = {};
export { uint8 as __exports };
